import { render, staticRenderFns } from "./TournamentRegisterCollapsed.vue?vue&type=template&id=6428f57b"
import script from "./TournamentRegisterCollapsed.vue?vue&type=script&lang=js"
export * from "./TournamentRegisterCollapsed.vue?vue&type=script&lang=js"
import style0 from "./TournamentRegisterCollapsed.vue?vue&type=style&index=0&id=6428f57b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports